import React, { Component } from "react"
import VideosForm from './components/video-form'
import { videosService } from '../../services/tibesa.api'
import Swal from 'sweetalert2'

export default class VideoAdd extends Component {

    submitChanges(formData) {
        Swal.fire({
            title: '¿Seguro que deseas guardar el Video?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí',
            cancelButtonText: 'Cancelar',
            showLoaderOnConfirm: true,
            preConfirm: () => {
                return videosService.create(formData)
                    .then(response => {
                        return response;
                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                            `Error en la petición: ${error}`
                        )
                    });
            },
            allowOutsideClick: () => !Swal.isLoading()
        })
            .then((response) => {
                console.log(response);
                if (response.value && response.value.data && response.value.data.status == 200) {
                    Swal.fire(
                        '¡Perfecto!',
                        '¡Nueva plantilla creada!',
                        'success'
                    ).then(() => {
                        if (response.value.data.results) {
                            window.location.href = `/videos/${response.value.data.results}`;
                        }
                        else {
                            window.location.href = '/videos';
                        }
                    });
                } else if(!response.dismiss == 'cancel') {
                    Swal.fire(
                        'Algo salio mal :C',
                        'Hubo un error al realizar la petición',
                        'error'
                      );
                }
            });
    }


    render() {
        return (
            <>
                <div className="air__utils__heading">
                    <a href="/videos">Listado de Videos</a><span>{" "}/{" "}Agregar Video</span>
                </div>
                <VideosForm onSubmit={this.submitChanges}></VideosForm>
            </>
        )
    }
}
